<template>
    <BRow>       
        <!-- Redsys -->
        <BCol md="4">
            <BCard>
                <AppCollapse>
                    <AppCollapseItem title="Redsys">
                        <TextInputValidated vsType="password" class="p-0 my-1" vsName="Clave secreta" :vsModel.sync="settings.redsys_key" vsLabel="redsys_key" />
                        <TextInputValidated class="p-0 my-1" vsName="URL de notificación" :vsModel.sync="settings.redsys_url_notification" vsLabel="redsys_url_notification" />
                        <TextInputValidated class="p-0 my-1" vsName="URL de retorno correcto (OK)" :vsModel.sync="settings.redsys_url_ok" vsLabel="redsys_url_ok" />
                        <TextInputValidated class="p-0 my-1" vsName="URL de retorno incorrecto (KO)" :vsModel.sync="settings.redsys_url_ko" vsLabel="redsys_url_ko" />
                        <TextInputValidated class="p-0 my-1" vsName="Merchant code" :vsModel.sync="settings.redsys_merchant_code" vsLabel="redsys_merchant_code" />
                        <TextInputValidated class="p-0 my-1" vsName="Terminal" :vsModel.sync="settings.redsys_terminal" vsLabel="redsys_terminal" />
                        <TextInputValidated class="p-0 my-1" vsName="Entorno" :vsModel.sync="settings.redsys_enviroment" vsLabel="redsys_enviroment" />
                        <TextInputValidated class="p-0 my-1" vsName="Nombre de comercio" :vsModel.sync="settings.redsys_tradename" vsLabel="redsys_tradename" />
                        <BButton @click="onSubmit()" variant="primary">Actualizar</BButton>
                    </AppCollapseItem>
                </AppCollapse>
            </BCard>
        </BCol>

        <!-- Webhooks -->
        <BCol md="4">
            <BCard>
                <AppCollapse>
                    <AppCollapseItem title="Webhooks">
                        <span class="text-muted">No disponible</span>
                    </AppCollapseItem>
                </AppCollapse>
            </BCard>
        </BCol>

        <!-- Brevo -->
        <BCol md="4">
            <BCard>
                <AppCollapse>
                    <AppCollapseItem title="Brevo">
                        <span class="text-muted">No disponible</span>
                    </AppCollapseItem>
                </AppCollapse>
            </BCard>
        </BCol>

        <!-- Moodle -->
        <BCol md="12" v-if="$existsModule('Moodle')">
            <BCard >
                <AppCollapse>
                    <AppCollapseItem title="Moodle">
                        <BCol md="4">
                            <TextInputValidated vsType="password" class="p-0 my-1" vsName="Token de acceso" :vsModel.sync="settings.moodle_token" vsLabel="moodle_token" />
                            <TextInputValidated class="p-0 my-1" vsName="Url del Moodle" :vsModel.sync="settings.moodle_url" vsLabel="moodle_url" />
                            <BButton @click="onSubmit()" variant="primary">Actualizar</BButton>

                        </BCol>
                    </AppCollapseItem>
                </AppCollapse>
            </BCard>
        </BCol>
    </BRow>
</template>
<script>
import { BButton, BCard, BCol, BRow } from 'bootstrap-vue';
import { updateSettings } from '@/composables/settingsService'
import { inject } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import popups from '@/hooks/popups';
import SettingsTabSyncs from './SettingsTabSyncs.vue';
export default {
    components: { BCard, AppCollapse, AppCollapseItem, BRow, BCol, TextInputValidated, BButton, SettingsTabSyncs, SettingsTabSyncs },
    setup() {
        const { errorToast, successToast } = popups()
        const settings = inject('settings')

        /**
         * Enviar formulario de actualización de ajustes
         */
        const onSubmit = async function() {
            const res = await updateSettings(settings.value)
            if(res.success) {
                successToast('Actualizados ajustes de integraciones')
            } else {
                errorToast('No se han podido actualizar los ajustes de integraciones')
            }
        }
        
        return {
            settings,
            onSubmit
        }
    }
}


</script>